import { ConverterRegistry } from '../../core/converter';
import { BrowserImageConverter, type ImageConverterDeps } from './browser-image-converter';

export function registerImageEngines(registry: ConverterRegistry, deps: ImageConverterDeps = {}): ConverterRegistry {
  registry.register(new BrowserImageConverter(deps));
  return registry;
}

export function createImageRegistry(deps: ImageConverterDeps = {}): ConverterRegistry {
  return registerImageEngines(new ConverterRegistry(), deps);
}
